import { render, staticRenderFns } from "./SignUpForUpdates.vue?vue&type=template&id=259f52c2&scoped=true&"
import script from "./SignUpForUpdates.vue?vue&type=script&lang=js&"
export * from "./SignUpForUpdates.vue?vue&type=script&lang=js&"
import style0 from "./SignUpForUpdates.vue?vue&type=style&index=0&id=259f52c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259f52c2",
  null
  
)

export default component.exports